import React from 'react';

import TextInput from './TextInput';
import NumericInput from './NumericInput';
import RadioInput from './RadioInput';
import CheckboxesInput from './CheckboxesInput';
import BooleanInput from './BooleanInput';
import DateTimeInput from './DateTimeInput';
import ImageInput from './ImageInput';
import CatalogInput from './CatalogInput';
import MultiCatalogInput from './MultiCatalogInput';
import MultiNumericInput from './MultiNumericInput';

function AnswerInput(props) {
  const {question} = props;

  switch (question.type) {
    case 'SCANNED_CODE':
    case 'TEXT':
      return <TextInput {...props} />;
    case 'NUMERIC':
      return <NumericInput {...props} />;
    case 'RADIO':
      return <RadioInput {...props} />;
    case 'CHECKBOXES':
      return <CheckboxesInput {...props} />;
    case 'BOOLEAN':
      return <BooleanInput {...props} />;
    case 'DATETIME':
      return <DateTimeInput {...props} />;
    case 'IMAGE':
      return <ImageInput {...props} />;
    case 'CATALOG_RADIO':
      return <CatalogInput {...props} />;
    case 'CATALOG_CHECKBOX':
      return <MultiCatalogInput {...props} />;
    case 'MULTI_NUMERIC':
      return <MultiNumericInput {...props} />;
    default:
      throw new Error(`Unhandled question type: ${question.type}`);
  }
}

export default AnswerInput;